<app-admin_header></app-admin_header>
  
<h2 class="welcome-message">Welcome to Admin Page</h2>

